import React, { useEffect, useState } from 'react'
import Confetti from 'react-confetti'

import { Footer } from '../../components/email'
import { Form } from '../../components/email/form'
import { ampEvent } from '../../utils/amplitude'

import './styles.scss'

const EmailScreen = () => {
	const [isActive, setIsActive] = useState(false)
	const [checkboxes, setCheckboxes] = useState([
		{ isChecked: true },
		{ isChecked: true },
	])

	const updateCheckboxStatus = idx => {
		setCheckboxes(
			checkboxes.map((checkbox, index) => {
				if (idx === index) {
					checkbox.isChecked = !checkbox.isChecked
				}
				return checkbox
			}),
		)
	}

	useEffect(() => {
		setTimeout(() => {
			ampEvent('email shown')
			setIsActive(true)
		}, 350)
	}, [])

	return (
		<div className={`email ${isActive ? 'email--active' : ''}`}>
			<Confetti numberOfPieces={300} recycle={false} />
			<Form setIsActive={setIsActive} checkboxes={checkboxes} />
			<Footer
				checkboxes={checkboxes}
				updateCheckboxStatus={updateCheckboxStatus}
			/>
		</div>
	)
}

export { EmailScreen }
